import { getAppDomainPreset, normalizeAppRuntimeEnv } from '@/config/domainPresets'

/**
 * 按当前运行环境主站域名与作品 gindex 拼接作品页地址；非正式环境附加 `testPath=true`。
 * @param gindex 作品 gindex。
 * @param runtimeEnv 运行环境，默认取构建时 `import.meta.env`。
 * @returns 作品页完整 URL；gindex 为空时返回 null。
 */
export function buildPublishedGamePageUrl(gindex: string, runtimeEnv?: string): string | null {
  const cleanGindex = String(gindex || '').trim()
  if (!cleanGindex) return null
  const env = normalizeAppRuntimeEnv(runtimeEnv ?? import.meta.env.MODE ?? import.meta.env.VITE_APP_ENV)
  const website = getAppDomainPreset(env).website.replace(/\/+$/g, '')
  const url = new URL(`${website}/game/${cleanGindex}`)
  if (env !== 'prod') {
    url.searchParams.set('testPath', 'true')
  }
  return url.toString()
}
